import { openBlock as n, createElementBlock as e, createElementVNode as t, createStaticVNode as h } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 -960 960 960"
}, l = /* @__PURE__ */ t("path", { d: "M450-200v-250H200v-60h250v-250h60v250h250v60H510v250h-60Z" }, null, -1), i = [
  l
];
function r(c, s) {
  return n(), e("svg", o, i);
}
const y3 = { render: r }, d = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}, _ = /* @__PURE__ */ t("path", {
  stroke: "#FAD200",
  "stroke-width": "3",
  d: "M18.439 18.045 1.469 1.074"
}, null, -1), a = [
  _
];
function w(c, s) {
  return n(), e("svg", d, a);
}
const S3 = { render: w }, v = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "15",
  fill: "none"
}, g = /* @__PURE__ */ t("path", {
  fill: "#FAD200",
  d: "M7 9.437A1.932 1.932 0 0 0 8.937 7.5 1.932 1.932 0 0 0 7 5.564 1.932 1.932 0 0 0 5.063 7.5c0 1.074.864 1.937 1.937 1.937Z"
}, null, -1), $ = /* @__PURE__ */ t("path", {
  fill: "#FAD200",
  d: "M9.917 8.095A2.98 2.98 0 0 1 7 10.475a2.98 2.98 0 0 1-2.917-2.38H.023A6.99 6.99 0 0 0 6.988 14.5c3.664 0 6.662-2.823 6.965-6.405H9.917ZM4.083 6.905A2.98 2.98 0 0 1 7 4.525a2.98 2.98 0 0 1 2.917 2.38h4.06A6.99 6.99 0 0 0 7.012.5C3.348.5.338 3.323.023 6.905h4.06Z"
}, null, -1), f = [
  g,
  $
];
function u(c, s) {
  return n(), e("svg", v, f);
}
const D3 = { render: u }, p = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, m = /* @__PURE__ */ t("path", {
  fill: "#fff",
  d: "M6.4 18.654 5.346 17.6l5.6-5.6-5.6-5.6L6.4 5.346l5.6 5.6 5.6-5.6L18.654 6.4l-5.6 5.6 5.6 5.6-1.054 1.054-5.6-5.6-5.6 5.6Z"
}, null, -1), Z = [
  m
];
function x(c, s) {
  return n(), e("svg", p, Z);
}
const O3 = { render: x }, A = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}, M = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "m9 11.279-4.24-4.24.79-.79L9 9.698l3.45-3.45.79.79L9 11.278Z"
}, null, -1), H = [
  M
];
function C(c, s) {
  return n(), e("svg", A, H);
}
const P3 = { render: C }, L = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}, E = /* @__PURE__ */ t("path", {
  fill: "#BEBEBE",
  d: "m9 11.279-4.24-4.24.79-.79L9 9.698l3.45-3.45.79.79L9 11.278Z"
}, null, -1), k = [
  E
];
function V(c, s) {
  return n(), e("svg", L, k);
}
const I3 = { render: V }, B = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "97",
  height: "81",
  fill: "none"
}, F = /* @__PURE__ */ h('<path fill="#BEBEBE" d="M35.577 73.987c-1.296 0-2.398-.454-3.305-1.361-.908-.908-1.362-2.01-1.362-3.306 0-1.295.454-2.397 1.362-3.305.907-.907 2.01-1.361 3.305-1.361 1.296 0 2.397.454 3.305 1.361.908.908 1.361 2.01 1.361 3.305 0 1.296-.453 2.398-1.361 3.306-.908.907-2.01 1.361-3.305 1.361Zm25.846 0c-1.296 0-2.397-.454-3.305-1.361-.908-.908-1.362-2.01-1.362-3.306 0-1.295.454-2.397 1.362-3.305.908-.907 2.01-1.361 3.305-1.361 1.296 0 2.397.454 3.305 1.361.908.908 1.362 2.01 1.362 3.305 0 1.296-.454 2.398-1.362 3.306-.908.907-2.01 1.361-3.305 1.361ZM32.541 31.833 39.3 45.987h18.18c.153 0 .29-.038.41-.115.12-.077.222-.184.307-.32l7.154-13c.103-.189.111-.355.026-.5-.086-.146-.23-.219-.436-.219h-32.4Zm-1.918-4h37.025c1.091 0 1.916.464 2.475 1.393.559.928.585 1.876.08 2.843l-8.544 15.477a4.822 4.822 0 0 1-1.736 1.797 4.537 4.537 0 0 1-2.367.644H38.1l-3.087 5.641c-.137.205-.141.428-.013.667.128.24.32.359.577.359H66.09v4H35.577c-1.778 0-3.114-.767-4.008-2.3-.894-1.534-.925-3.064-.095-4.593l3.805-6.84L25.578 26.5H20.5v-4h7.59l2.533 5.333Z"></path><path stroke="#BEBEBE" stroke-width="2" d="M81.5 16.5v10M86.5 21.5h-10M43.5 8.5v8M47.5 12.5h-8"></path><circle cx="4.5" cy="30.5" r="2" stroke="#BEBEBE" stroke-width="2"></circle><circle cx="65.5" cy="5.5" r="2" stroke="#BEBEBE" stroke-width="2"></circle><circle cx="20.5" cy="7.5" r="1" stroke="#BEBEBE" stroke-width="2"></circle>', 5), y = [
  F
];
function S(c, s) {
  return n(), e("svg", B, y);
}
const N3 = { render: S }, D = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  fill: "none"
}, O = /* @__PURE__ */ t("path", {
  fill: "#7E7E7E",
  d: "M7.654 22.058c-.486 0-.9-.17-1.24-.51-.34-.341-.51-.754-.51-1.24s.17-.9.51-1.24c.34-.34.754-.51 1.24-.51s.899.17 1.24.51c.34.34.51.754.51 1.24s-.17.899-.51 1.24c-.341.34-.754.51-1.24.51Zm9.692 0c-.486 0-.899-.17-1.24-.51-.34-.341-.51-.754-.51-1.24s.17-.9.51-1.24c.341-.34.754-.51 1.24-.51s.9.17 1.24.51c.34.34.51.754.51 1.24s-.17.899-.51 1.24c-.34.34-.754.51-1.24.51ZM6.516 6.25l2.534 5.308h6.817a.278.278 0 0 0 .154-.044.376.376 0 0 0 .116-.12l2.682-4.875c.039-.07.042-.133.01-.187-.032-.055-.087-.082-.164-.082H6.515Zm-.72-1.5h13.885c.409 0 .718.174.928.522.21.348.22.704.03 1.066l-3.204 5.804a1.807 1.807 0 0 1-.651.674c-.27.161-.566.242-.888.242H8.6l-1.158 2.115c-.051.077-.053.16-.005.25.049.09.12.135.217.135h11.442v1.5H7.654c-.667 0-1.168-.288-1.503-.863-.335-.575-.347-1.149-.036-1.722l1.427-2.565L3.904 4.25H2v-1.5h2.846l.95 2Z"
}, null, -1), P = [
  O
];
function I(c, s) {
  return n(), e("svg", D, P);
}
const b3 = { render: I }, N = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  fill: "none"
}, b = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "M7.654 22.058c-.486 0-.9-.17-1.24-.51-.34-.341-.51-.754-.51-1.24s.17-.9.51-1.24c.34-.34.754-.51 1.24-.51s.899.17 1.24.51c.34.34.51.754.51 1.24s-.17.899-.51 1.24c-.341.34-.754.51-1.24.51Zm9.692 0c-.486 0-.899-.17-1.24-.51-.34-.341-.51-.754-.51-1.24s.17-.9.51-1.24c.341-.34.754-.51 1.24-.51s.9.17 1.24.51c.34.34.51.754.51 1.24s-.17.899-.51 1.24c-.34.34-.754.51-1.24.51ZM6.516 6.25l2.534 5.308h6.817a.278.278 0 0 0 .154-.044.376.376 0 0 0 .116-.12l2.682-4.875c.039-.07.042-.133.01-.187-.032-.055-.087-.082-.164-.082H6.515Zm-.72-1.5h13.885c.409 0 .718.174.928.522.21.348.22.704.03 1.066l-3.204 5.804a1.807 1.807 0 0 1-.651.674c-.27.161-.566.242-.888.242H8.6l-1.158 2.115c-.051.077-.053.16-.005.25.049.09.12.135.217.135h11.442v1.5H7.654c-.667 0-1.168-.288-1.503-.863-.335-.575-.347-1.149-.036-1.722l1.427-2.565L3.904 4.25H2v-1.5h2.846l.95 2Z"
}, null, -1), T = [
  b
];
function U(c, s) {
  return n(), e("svg", N, T);
}
const T3 = { render: U }, z = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "81",
  height: "80",
  fill: "none"
}, G = /* @__PURE__ */ h('<path fill="url(#a)" d="m35.77 54.18 22.41-22.41-3.513-3.513-18.898 18.897-9.5-9.5-3.512 3.513 13.012 13.012Zm4.736 17.487c-4.38 0-8.497-.831-12.35-2.494-3.854-1.662-7.207-3.918-10.057-6.767-2.851-2.85-5.108-6.2-6.771-10.053-1.663-3.852-2.494-7.968-2.494-12.347 0-4.38.83-8.497 2.493-12.35 1.662-3.854 3.918-7.207 6.767-10.057 2.85-2.851 6.2-5.108 10.053-6.771 3.852-1.663 7.968-2.494 12.348-2.494 4.38 0 8.496.83 12.35 2.493 3.854 1.662 7.206 3.918 10.057 6.767 2.85 2.85 5.107 6.2 6.77 10.053 1.663 3.852 2.495 7.968 2.495 12.348 0 4.38-.831 8.496-2.494 12.35-1.662 3.854-3.918 7.206-6.767 10.057-2.85 2.85-6.2 5.107-10.053 6.77-3.852 1.663-7.968 2.495-12.347 2.495Zm-.006-5c7.444 0 13.75-2.584 18.917-7.75 5.166-5.167 7.75-11.473 7.75-18.917 0-7.444-2.584-13.75-7.75-18.917-5.167-5.166-11.473-7.75-18.917-7.75-7.444 0-13.75 2.584-18.917 7.75-5.166 5.167-7.75 11.473-7.75 18.917 0 7.444 2.584 13.75 7.75 18.917 5.167 5.166 11.473 7.75 18.917 7.75Z"></path><defs><linearGradient id="a" x1="8.834" x2="73.746" y1="71.667" y2="70.005" gradientUnits="userSpaceOnUse"><stop stop-color="#FFA6DC"></stop><stop offset=".286" stop-color="#FFCC84"></stop><stop offset="1" stop-color="#FFED4A"></stop></linearGradient></defs>', 2), R = [
  G
];
function W(c, s) {
  return n(), e("svg", z, R);
}
const U3 = { render: W }, q = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}, j = /* @__PURE__ */ t("path", {
  fill: "#fff",
  d: "M7.163 13.24 3.162 9.239l.801-.802 3.2 3.199 6.873-6.874.803.802-7.676 7.676Z"
}, null, -1), J = [
  j
];
function K(c, s) {
  return n(), e("svg", q, J);
}
const z3 = { render: K }, Q = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}, X = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "m7.833 14.711-.878-.878L10.79 10 6.955 6.166l.878-.878L12.545 10 7.833 14.71Z"
}, null, -1), Y = [
  X
];
function t1(c, s) {
  return n(), e("svg", Q, Y);
}
const G3 = { render: t1 }, n1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, e1 = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  "fill-opacity": ".4",
  d: "m8.4 16.654 3.6-3.6 3.6 3.6 1.054-1.054-3.6-3.6 3.6-3.6L15.6 7.346l-3.6 3.6-3.6-3.6L7.346 8.4l3.6 3.6-3.6 3.6L8.4 16.654Zm3.602 4.846a9.255 9.255 0 0 1-3.705-.748 9.598 9.598 0 0 1-3.018-2.03 9.591 9.591 0 0 1-2.03-3.016 9.245 9.245 0 0 1-.749-3.704c0-1.314.25-2.55.748-3.705a9.597 9.597 0 0 1 2.03-3.018 9.592 9.592 0 0 1 3.016-2.03 9.245 9.245 0 0 1 3.704-.749c1.314 0 2.55.25 3.705.748a9.597 9.597 0 0 1 3.018 2.03 9.592 9.592 0 0 1 2.03 3.016 9.245 9.245 0 0 1 .749 3.704c0 1.314-.25 2.55-.748 3.705a9.598 9.598 0 0 1-2.03 3.018 9.592 9.592 0 0 1-3.016 2.03 9.245 9.245 0 0 1-3.704.749Z"
}, null, -1), c1 = [
  e1
];
function s1(c, s) {
  return n(), e("svg", n1, c1);
}
const R3 = { render: s1 }, h1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}, o1 = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "M9.979 18.292a7.315 7.315 0 0 1-2.906-.584 7.479 7.479 0 0 1-2.375-1.593 7.623 7.623 0 0 1-1.604-2.375 7.242 7.242 0 0 1-.594-2.922c0-1.038.198-2.01.594-2.917.395-.906.93-1.7 1.604-2.38a7.393 7.393 0 0 1 2.375-1.604 7.316 7.316 0 0 1 2.906-.584c1.028 0 1.997.195 2.906.584.91.389 1.705.923 2.386 1.604a7.531 7.531 0 0 1 1.604 2.38c.389.907.583 1.88.583 2.917a7.354 7.354 0 0 1-.583 2.922 7.394 7.394 0 0 1-1.604 2.375 7.604 7.604 0 0 1-2.386 1.593 7.316 7.316 0 0 1-2.906.584Zm2.52-4.084.876-.875-2.709-2.708V6.667h-1.25v4.458l3.084 3.083ZM4.46 1.938l.874.875-3.417 3.291-.874-.875 3.416-3.292Zm11.04 0 3.417 3.291-.875.875-3.416-3.292.875-.874ZM9.98 17.041c1.736 0 3.208-.605 4.417-1.814 1.208-1.209 1.812-2.68 1.812-4.416 0-1.736-.604-3.208-1.813-4.416-1.21-1.208-2.681-1.813-4.417-1.813-1.735 0-3.207.605-4.416 1.814-1.208 1.209-1.812 2.68-1.812 4.416 0 1.736.604 3.208 1.813 4.416 1.21 1.209 2.681 1.813 4.417 1.813Z"
}, null, -1), l1 = [
  o1
];
function i1(c, s) {
  return n(), e("svg", h1, l1);
}
const W3 = { render: i1 }, r1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "10",
  fill: "none"
}, d1 = /* @__PURE__ */ t("circle", {
  cx: "5.5",
  cy: "5",
  r: "5",
  fill: "#EBEBEB"
}, null, -1), _1 = [
  d1
];
function a1(c, s) {
  return n(), e("svg", r1, _1);
}
const q3 = { render: a1 }, w1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, v1 = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "M4.308 21.2c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 0 1-.525-1.283V6.008c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h8.54l-1.5 1.5h-7.04a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v13.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096h13.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212v-7.056l1.5-1.5v8.556c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H4.308ZM15.53 4.621l1.079 1.054-6.61 6.6V13.7h1.4l6.644-6.625 1.06 1.044-7.056 7.081H8.5v-3.548l7.03-7.03Zm3.573 3.498L15.53 4.621l2.288-2.288a1.76 1.76 0 0 1 1.294-.533c.506 0 .933.18 1.277.542l.977.983c.345.351.518.775.518 1.27 0 .496-.176.92-.527 1.27L19.104 8.12Z"
}, null, -1), g1 = [
  v1
];
function $1(c, s) {
  return n(), e("svg", w1, g1);
}
const j3 = { render: $1 }, f1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}, u1 = /* @__PURE__ */ t("path", {
  fill: "#F24141",
  d: "M10 13.942c.19 0 .35-.065.48-.194a.651.651 0 0 0 .193-.48c0-.19-.065-.35-.194-.479a.651.651 0 0 0-.48-.193c-.19 0-.35.064-.479.193a.651.651 0 0 0-.193.48c0 .19.064.35.193.48a.651.651 0 0 0 .48.193Zm-.625-3.045h1.25v-5h-1.25v5Zm.626 7.02a7.713 7.713 0 0 1-3.087-.624A7.997 7.997 0 0 1 4.4 15.601a7.994 7.994 0 0 1-1.693-2.513 7.704 7.704 0 0 1-.624-3.087c0-1.095.208-2.124.624-3.088A7.997 7.997 0 0 1 4.398 4.4a7.993 7.993 0 0 1 2.514-1.692 7.705 7.705 0 0 1 3.087-.624c1.094 0 2.124.208 3.087.623.963.416 1.802.98 2.514 1.692a7.992 7.992 0 0 1 1.693 2.513c.416.963.623 1.992.623 3.087a7.71 7.71 0 0 1-.623 3.088 7.994 7.994 0 0 1-1.692 2.514 7.99 7.99 0 0 1-2.513 1.693 7.705 7.705 0 0 1-3.087.623Z"
}, null, -1), p1 = [
  u1
];
function m1(c, s) {
  return n(), e("svg", f1, p1);
}
const J3 = { render: m1 }, Z1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}, x1 = /* @__PURE__ */ t("path", {
  fill: "#666",
  d: "M4.423 17.084c-.421 0-.777-.146-1.069-.438a1.454 1.454 0 0 1-.438-1.069V4.423c0-.42.146-.777.438-1.069a1.454 1.454 0 0 1 1.069-.437h5.256v1.25H4.423a.245.245 0 0 0-.176.08.245.245 0 0 0-.08.176v11.154c0 .064.026.123.08.177.053.053.112.08.176.08h11.154a.245.245 0 0 0 .176-.08.245.245 0 0 0 .08-.177v-5.256h1.25v5.256c0 .421-.146.778-.437 1.07a1.454 1.454 0 0 1-1.07.437H4.424Zm3.676-4.305-.878-.878 7.734-7.734h-3.289v-1.25h5.417v5.417h-1.25V5.045L8.1 12.78Z"
}, null, -1), A1 = [
  x1
];
function M1(c, s) {
  return n(), e("svg", Z1, A1);
}
const K3 = { render: M1 }, H1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}, C1 = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "M4.423 17.084c-.421 0-.777-.146-1.069-.438a1.454 1.454 0 0 1-.438-1.069V4.423c0-.42.146-.777.438-1.069a1.454 1.454 0 0 1 1.069-.437h5.256v1.25H4.423a.245.245 0 0 0-.176.08.245.245 0 0 0-.08.176v11.154c0 .064.026.123.08.177.053.053.112.08.176.08h11.154a.245.245 0 0 0 .176-.08.245.245 0 0 0 .08-.177v-5.256h1.25v5.256c0 .421-.146.778-.437 1.07a1.454 1.454 0 0 1-1.07.437H4.424Zm3.676-4.305-.878-.878 7.734-7.734h-3.289v-1.25h5.417v5.417h-1.25V5.045L8.1 12.78Z"
}, null, -1), L1 = [
  C1
];
function E1(c, s) {
  return n(), e("svg", H1, L1);
}
const Q3 = { render: E1 }, k1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}, V1 = /* @__PURE__ */ t("path", {
  fill: "#1C1B1F",
  d: "M9.991 14.68a.82.82 0 0 0 .603-.247.821.821 0 0 0 .246-.604.82.82 0 0 0-.247-.603.821.821 0 0 0-.603-.246.82.82 0 0 0-.603.247.821.821 0 0 0-.246.603c0 .238.082.44.247.603a.821.821 0 0 0 .603.246Zm-.59-2.985h1.173c.01-.41.07-.738.18-.983.11-.245.375-.57.797-.975.367-.367.648-.705.843-1.015.194-.31.292-.677.292-1.1 0-.717-.258-1.278-.773-1.68-.516-.404-1.126-.606-1.83-.606-.695 0-1.27.186-1.726.557a3.14 3.14 0 0 0-.975 1.312l1.07.43c.102-.277.275-.547.52-.81.247-.262.611-.393 1.096-.393.492 0 .856.135 1.092.405a1.324 1.324 0 0 1 .111 1.667 3.69 3.69 0 0 1-.617.682c-.547.493-.893.887-1.037 1.18-.144.295-.216.737-.216 1.33Zm.6 6.221a7.713 7.713 0 0 1-3.087-.623A7.997 7.997 0 0 1 4.4 15.601a7.994 7.994 0 0 1-1.693-2.513 7.704 7.704 0 0 1-.623-3.087c0-1.095.207-2.124.623-3.088A7.997 7.997 0 0 1 4.399 4.4a7.993 7.993 0 0 1 2.513-1.692 7.705 7.705 0 0 1 3.087-.624c1.095 0 2.124.208 3.087.623.964.416 1.802.98 2.514 1.692a7.994 7.994 0 0 1 1.693 2.513c.416.963.624 1.992.624 3.087a7.713 7.713 0 0 1-.623 3.088 7.997 7.997 0 0 1-1.692 2.514 7.993 7.993 0 0 1-2.514 1.693 7.705 7.705 0 0 1-3.086.623Zm0-1.25c1.86 0 3.437-.646 4.728-1.937 1.292-1.292 1.938-2.868 1.938-4.73 0-1.86-.646-3.437-1.938-4.729C13.438 3.98 11.861 3.333 10 3.333c-1.861 0-3.437.646-4.729 1.937C3.979 6.562 3.333 8.14 3.333 10c0 1.86.646 3.437 1.938 4.729 1.292 1.291 2.868 1.937 4.73 1.937Z"
}, null, -1), B1 = [
  V1
];
function F1(c, s) {
  return n(), e("svg", k1, B1);
}
const X3 = { render: F1 }, y1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "#0A0A0A"
}, S1 = /* @__PURE__ */ t("path", { d: "M11.925 21c-2.483 0-4.592-.88-6.325-2.637C3.867 16.604 3 14.475 3 11.975h1.5c0 2.083.717 3.858 2.15 5.325 1.433 1.467 3.192 2.2 5.275 2.2 2.117 0 3.908-.742 5.375-2.225s2.2-3.283 2.2-5.4c0-2.067-.742-3.813-2.225-5.237-1.483-1.425-3.267-2.138-5.35-2.138a6.799 6.799 0 0 0-3.188.775 8.693 8.693 0 0 0-2.587 2.05h2.625v1.5H3.55v-5.2h1.5v2.65a9.514 9.514 0 0 1 3.087-2.4A8.504 8.504 0 0 1 11.925 3c1.25 0 2.425.233 3.525.7a9.237 9.237 0 0 1 2.887 1.912 8.978 8.978 0 0 1 1.95 2.838 8.619 8.619 0 0 1 .713 3.5c0 1.25-.238 2.425-.712 3.525a9.05 9.05 0 0 1-1.95 2.875 9.305 9.305 0 0 1-2.888 1.938 8.796 8.796 0 0 1-3.525.712Zm3.2-4.925-3.85-3.8v-5.35h1.5v4.725L16.2 15l-1.075 1.075Z" }, null, -1), D1 = [
  S1
];
function O1(c, s) {
  return n(), e("svg", y1, D1);
}
const Y3 = { render: O1 }, P1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none"
}, I1 = /* @__PURE__ */ t("path", {
  fill: "#1C1B1F",
  d: "M7.875 12.8h1.25V8.01h-1.25v4.79ZM8.5 6.584c.19 0 .35-.065.48-.194a.651.651 0 0 0 .193-.48c0-.19-.064-.35-.193-.479a.651.651 0 0 0-.48-.193c-.19 0-.35.064-.48.193a.651.651 0 0 0-.193.48c0 .19.065.35.194.48a.651.651 0 0 0 .48.193Zm.002 10.176a7.711 7.711 0 0 1-3.088-.623A7.997 7.997 0 0 1 2.9 14.444a7.994 7.994 0 0 1-1.693-2.513 7.705 7.705 0 0 1-.624-3.087c0-1.095.208-2.124.624-3.088a7.997 7.997 0 0 1 1.692-2.514 7.993 7.993 0 0 1 2.513-1.693A7.704 7.704 0 0 1 8.499.926c1.095 0 2.124.208 3.087.623.964.416 1.802.98 2.514 1.692a7.994 7.994 0 0 1 1.693 2.513c.416.963.624 1.992.624 3.087a7.713 7.713 0 0 1-.624 3.088 7.999 7.999 0 0 1-1.691 2.514 7.995 7.995 0 0 1-2.514 1.693 7.705 7.705 0 0 1-3.086.623ZM8.5 15.51c1.861 0 3.438-.646 4.73-1.937 1.291-1.292 1.937-2.868 1.937-4.73 0-1.86-.646-3.437-1.938-4.729-1.291-1.291-2.868-1.937-4.729-1.937-1.861 0-3.437.646-4.729 1.937-1.292 1.292-1.938 2.868-1.938 4.73 0 1.86.646 3.437 1.938 4.729 1.292 1.291 2.868 1.937 4.73 1.937Z"
}, null, -1), N1 = [
  I1
];
function b1(c, s) {
  return n(), e("svg", P1, N1);
}
const t5 = { render: b1 }, T1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none"
}, U1 = /* @__PURE__ */ h('<path fill="url(#a)" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#fff" d="M24.523 32h-9.046a7.455 7.455 0 0 1-5.287-2.19A7.448 7.448 0 0 1 8 24.523v-9.046a7.451 7.451 0 0 1 2.19-5.287A7.446 7.446 0 0 1 15.477 8h9.046a7.452 7.452 0 0 1 5.287 2.19A7.45 7.45 0 0 1 32 15.477v9.046a7.455 7.455 0 0 1-2.19 5.287A7.448 7.448 0 0 1 24.523 32Zm-9.046-21.712c-1.386 0-2.689.54-3.67 1.52a5.156 5.156 0 0 0-1.519 3.67v9.045c0 1.386.54 2.689 1.52 3.67.98.98 2.283 1.52 3.67 1.52h9.045c1.386 0 2.689-.54 3.67-1.52a5.156 5.156 0 0 0 1.519-3.67v-9.046c0-1.386-.54-2.689-1.52-3.67a5.156 5.156 0 0 0-3.67-1.519h-9.044Z"></path><path fill="#fff" d="M20 26.026a6.005 6.005 0 0 1-4.261-1.765 6.008 6.008 0 0 1-1.765-4.26 6.005 6.005 0 0 1 1.765-4.26A6.008 6.008 0 0 1 20 13.972a6.004 6.004 0 0 1 4.26 1.765A6.005 6.005 0 0 1 26.027 20a6.001 6.001 0 0 1-1.765 4.26 6.008 6.008 0 0 1-4.26 1.766Zm0-9.764c-.998 0-1.937.39-2.643 1.095A3.713 3.713 0 0 0 16.262 20c0 .999.389 1.937 1.095 2.643A3.713 3.713 0 0 0 20 23.738c.998 0 1.937-.388 2.643-1.095A3.713 3.713 0 0 0 23.738 20c0-.998-.389-1.937-1.095-2.643A3.713 3.713 0 0 0 20 16.262ZM27.108 14.612a1.404 1.404 0 1 0-1.986-1.986 1.404 1.404 0 0 0 1.986 1.986Z"></path><defs><linearGradient id="a" x1="5.858" x2="34.142" y1="34.142" y2="5.858" gradientUnits="userSpaceOnUse"><stop stop-color="#FFC107"></stop><stop offset=".51" stop-color="#F44336"></stop><stop offset=".99" stop-color="#9C27B0"></stop></linearGradient></defs>', 4), z1 = [
  U1
];
function G1(c, s) {
  return n(), e("svg", T1, z1);
}
const n5 = { render: G1 }, R1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "6",
  fill: "none"
}, W1 = /* @__PURE__ */ t("path", {
  fill: "#fff",
  d: "M4.75 6 .42.75h8.66L4.75 6Z"
}, null, -1), q1 = [
  W1
];
function j1(c, s) {
  return n(), e("svg", R1, q1);
}
const e5 = { render: j1 }, J1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none"
}, K1 = /* @__PURE__ */ t("path", {
  fill: "#00B900",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), Q1 = /* @__PURE__ */ t("path", {
  fill: "#fff",
  d: "M32 18.738C32 13.368 26.616 9 20 9c-6.617 0-12 4.368-12 9.738 0 4.814 4.269 8.846 10.035 9.608.39.084.923.258 1.058.593.122.303.08.78.038 1.084l-.172 1.028c-.05.303-.241 1.187 1.04.646 1.28-.54 6.91-4.069 9.428-6.967C31.167 22.822 32 20.888 32 18.738Z"
}, null, -1), X1 = /* @__PURE__ */ t("path", {
  fill: "#00B900",
  d: "M17.563 16.144h-.842a.234.234 0 0 0-.235.233v5.229c0 .13.105.232.235.232h.842c.13 0 .234-.104.234-.232v-5.23a.233.233 0 0 0-.234-.232ZM23.356 16.144h-.843a.234.234 0 0 0-.234.233v3.106l-2.395-3.236-.02-.023c-.003-.005-.01-.01-.013-.015l-.004-.004c-.004-.003-.007-.007-.013-.01l-.006-.003-.011-.008-.008-.004c-.004-.001-.008-.005-.013-.007a.014.014 0 0 1-.008-.004c-.004 0-.01-.004-.013-.006-.002 0-.006 0-.008-.002l-.013-.003c-.002 0-.006 0-.008-.002a.036.036 0 0 1-.013-.004h-.882a.234.234 0 0 0-.235.232v5.23c0 .13.105.232.235.232h.842c.13 0 .234-.105.234-.232v-3.107l2.4 3.24a.243.243 0 0 0 .059.057h.002c.003.004.01.006.015.01l.006.003c.003 0 .007.004.01.006.005 0 .009.004.012.004l.008.002c.006 0 .011.004.015.006h.004c.02.005.038.007.06.007h.841c.13 0 .235-.104.235-.232v-5.23a.233.233 0 0 0-.235-.232M15.533 20.53h-2.287v-4.153a.234.234 0 0 0-.234-.234h-.843a.234.234 0 0 0-.234.234v5.23a.234.234 0 0 0 .234.234h3.364c.13 0 .232-.105.232-.235v-.842a.234.234 0 0 0-.232-.235ZM28.004 17.454c.13 0 .233-.105.233-.235v-.842a.234.234 0 0 0-.233-.234h-3.363a.228.228 0 0 0-.162.066l-.002.002-.004.004a.233.233 0 0 0-.065.16v5.23a.234.234 0 0 0 .235.234h3.363c.13 0 .233-.105.233-.235v-.842a.234.234 0 0 0-.233-.234H25.72v-.885h2.287c.13 0 .233-.105.233-.234v-.842a.234.234 0 0 0-.233-.235H25.72v-.884h2.287l-.002.006Z"
}, null, -1), Y1 = [
  K1,
  Q1,
  X1
];
function t0(c, s) {
  return n(), e("svg", J1, Y1);
}
const c5 = { render: t0 }, n0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}, e0 = /* @__PURE__ */ t("path", {
  fill: "#666",
  d: "M13.333 18.045 5.29 10l8.044-8.045 1.183 1.183L7.654 10l6.862 6.862-1.183 1.183Z"
}, null, -1), c0 = [
  e0
];
function s0(c, s) {
  return n(), e("svg", n0, c0);
}
const s5 = { render: s0 }, h0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}, o0 = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "M13.333 18.045 5.29 10l8.044-8.045 1.183 1.183L7.654 10l6.862 6.862-1.183 1.183Z"
}, null, -1), l0 = [
  o0
];
function i0(c, s) {
  return n(), e("svg", h0, l0);
}
const h5 = { render: i0 }, r0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "31",
  fill: "none"
}, d0 = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "M8.855 30.084c-1.531 0-2.837-.54-3.917-1.62-1.079-1.08-1.619-2.39-1.619-3.933H.442V2.885c0-.785.285-1.461.854-2.03C1.866.284 2.543 0 3.327 0h27.93v7.87h4.75l7.05 9.415v7.246h-3.28c0 1.542-.54 2.854-1.62 3.934s-2.39 1.62-3.932 1.62c-1.538 0-2.845-.54-3.921-1.62-1.077-1.08-1.615-2.392-1.615-3.934H14.408c0 1.543-.543 2.855-1.628 3.934-1.085 1.08-2.393 1.62-3.925 1.62Zm.008-2.269c.91 0 1.683-.318 2.32-.955.637-.638.956-1.41.956-2.32 0-.909-.32-1.682-.956-2.319a3.158 3.158 0 0 0-2.32-.956c-.908 0-1.682.319-2.319.956a3.158 3.158 0 0 0-.956 2.32c0 .908.32 1.681.956 2.319.637.637 1.41.955 2.32.955Zm-6.151-5.553h1.08c.426-.952 1.092-1.739 1.999-2.362a5.24 5.24 0 0 1 3.037-.935c1.093 0 2.102.314 3.029.94.926.628 1.602 1.413 2.028 2.357h15.103V2.269H3.327a.588.588 0 0 0-.423.192.588.588 0 0 0-.192.424v19.377Zm31.52 5.553c.91 0 1.683-.318 2.32-.955.637-.638.956-1.41.956-2.32 0-.909-.319-1.682-.956-2.319a3.158 3.158 0 0 0-2.32-.956c-.908 0-1.681.319-2.319.956a3.158 3.158 0 0 0-.955 2.32c0 .908.318 1.681.956 2.319.637.637 1.41.955 2.319.955Zm-2.974-9.777h9.55l-5.973-7.9h-3.577v7.9Z"
}, null, -1), _0 = [
  d0
];
function a0(c, s) {
  return n(), e("svg", r0, _0);
}
const o5 = { render: a0 }, w0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "81",
  height: "80",
  fill: "none"
}, v0 = /* @__PURE__ */ t("path", {
  fill: "url(#a)",
  d: "M53.25 73.333 39.833 59.916l3.584-3.583 9.833 9.833 20.333-20.333 3.584 3.583L53.25 73.333Zm-12.917-37.25 27.834-17.75H12.5l27.833 17.75Zm0 5L12.167 23v37.666H33.5l5 5H12.167c-1.334 0-2.5-.5-3.5-1.5s-1.5-2.166-1.5-3.5V18.333c0-1.333.5-2.5 1.5-3.5s2.166-1.5 3.5-1.5h56.416c1.334 0 2.5.5 3.5 1.5s1.5 2.167 1.5 3.5v20.333l-5 5V23l-28.25 18.083Z"
}, null, -1), g0 = /* @__PURE__ */ t("defs", null, [
  /* @__PURE__ */ t("linearGradient", {
    id: "a",
    x1: "7.167",
    x2: "78.195",
    y1: "73.333",
    y2: "72.091",
    gradientUnits: "userSpaceOnUse"
  }, [
    /* @__PURE__ */ t("stop", { "stop-color": "#FFE24B" }),
    /* @__PURE__ */ t("stop", {
      offset: "1",
      "stop-color": "#FFEC3F"
    })
  ])
], -1), $0 = [
  v0,
  g0
];
function f0(c, s) {
  return n(), e("svg", w0, $0);
}
const l5 = { render: f0 }, u0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, p0 = /* @__PURE__ */ t("path", {
  fill: "#666",
  d: "M6.4 18.654 5.346 17.6l5.6-5.6-5.6-5.6L6.4 5.346l5.6 5.6 5.6-5.6L18.652 6.4l-5.6 5.6 5.6 5.6-1.053 1.054-5.6-5.6-5.6 5.6Z"
}, null, -1), m0 = [
  p0
];
function Z0(c, s) {
  return n(), e("svg", u0, m0);
}
const i5 = { render: Z0 }, x0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "20",
  fill: "none"
}, A0 = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "M5.853 14.587h11.666V4.17H5.853v10.417Zm0 1.25a1.2 1.2 0 0 1-.875-.375 1.2 1.2 0 0 1-.375-.875V2.92a1.2 1.2 0 0 1 .375-.875 1.2 1.2 0 0 1 .875-.375h11.666a1.2 1.2 0 0 1 .875.375c.25.25.375.542.375.875v11.667a1.2 1.2 0 0 1-.375.875 1.2 1.2 0 0 1-.875.375H5.853Zm-2.5 2.5a1.2 1.2 0 0 1-.875-.375 1.2 1.2 0 0 1-.375-.875V4.17h1.25v12.917h12.916v1.25H3.353Z"
}, null, -1), M0 = [
  A0
];
function H0(c, s) {
  return n(), e("svg", x0, M0);
}
const r5 = { render: H0 }, C0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "56",
  height: "56",
  fill: "none"
}, L0 = /* @__PURE__ */ t("path", {
  fill: "#FAB3B3",
  d: "M4.352 47.833 27.999 7l23.647 40.833H4.352Zm6.03-3.5h35.233L28 14 10.382 44.333ZM28 41.551c.534 0 .981-.18 1.343-.542.36-.36.541-.809.541-1.343 0-.533-.18-.981-.541-1.342-.362-.361-.81-.542-1.343-.542-.534 0-.982.18-1.343.542-.361.36-.542.809-.542 1.343 0 .533.18.981.542 1.342.361.361.809.542 1.343.542Zm-1.75-6.102h3.5V23.782h-3.5v11.667Z"
}, null, -1), E0 = [
  L0
];
function k0(c, s) {
  return n(), e("svg", C0, E0);
}
const d5 = { render: k0 }, V0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "39",
  height: "38",
  fill: "none"
}, B0 = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "M18.088 32.87h2.193v-2.505c1.815-.143 3.328-.7 4.538-1.673 1.21-.971 1.816-2.333 1.816-4.084 0-1.623-.474-2.936-1.422-3.939-.947-1.002-2.584-1.974-4.91-2.915-2.06-.813-3.474-1.53-4.238-2.15-.764-.62-1.146-1.477-1.146-2.57 0-1.058.404-1.92 1.212-2.584.807-.664 1.88-.996 3.219-.996 1 0 1.867.227 2.6.68.733.454 1.356 1.11 1.87 1.966l1.88-.88c-.567-1.065-1.304-1.905-2.212-2.52-.907-.615-1.943-.977-3.107-1.085V5.161h-2.193v2.454c-1.725.234-3.064.85-4.015 1.846-.951.998-1.427 2.189-1.427 3.574 0 1.556.484 2.792 1.452 3.707.968.916 2.497 1.79 4.587 2.623 2.22.908 3.725 1.724 4.513 2.448.789.725 1.183 1.656 1.183 2.795 0 1.233-.487 2.181-1.46 2.844-.973.663-2.12.994-3.44.994-1.262 0-2.398-.354-3.408-1.061-1.01-.708-1.754-1.683-2.23-2.924l-1.993.716c.687 1.43 1.53 2.546 2.527 3.346.997.8 2.201 1.38 3.611 1.742v2.604ZM19.25 38c-2.605 0-5.06-.5-7.365-1.498a19.334 19.334 0 0 1-6.048-4.089 19.334 19.334 0 0 1-4.089-6.048C.75 24.06.25 21.605.25 19c0-2.626.5-5.094 1.498-7.406.999-2.311 2.362-4.322 4.089-6.032 1.726-1.71 3.742-3.065 6.048-4.064C14.19.5 16.645 0 19.25 0c2.626 0 5.094.5 7.406 1.498 2.311.999 4.322 2.353 6.032 4.064 1.71 1.71 3.065 3.72 4.064 6.032.998 2.312 1.498 4.78 1.498 7.406 0 2.605-.5 5.06-1.498 7.365-.999 2.305-2.353 4.322-4.064 6.048-1.71 1.727-3.72 3.09-6.032 4.089C24.344 37.5 21.876 38 19.25 38Zm0-2.27c4.656 0 8.609-1.629 11.858-4.888C34.356 27.583 35.98 23.636 35.98 19c0-4.656-1.625-8.609-4.873-11.858-3.25-3.248-7.202-4.873-11.858-4.873-4.636 0-8.583 1.625-11.842 4.873C4.148 10.391 2.519 14.344 2.519 19c0 4.636 1.63 8.583 4.889 11.842 3.259 3.26 7.206 4.889 11.842 4.889Z"
}, null, -1), F0 = [
  B0
];
function y0(c, s) {
  return n(), e("svg", V0, F0);
}
const _5 = { render: y0 }, S0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}, D0 = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "M8.25 17.75v-5.5h1.5v2h8v1.5h-8v2h-1.5Zm-8-2v-1.5h5.5v1.5H.25Zm4-4v-2h-4v-1.5h4v-2h1.5v5.5h-1.5Zm4-2v-1.5h9.5v1.5h-9.5Zm4-4V.25h1.5v2h4v1.5h-4v2h-1.5Zm-12-2v-1.5h9.5v1.5H.25Z"
}, null, -1), O0 = [
  D0
];
function P0(c, s) {
  return n(), e("svg", S0, O0);
}
const a5 = { render: P0 }, I0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, N0 = /* @__PURE__ */ t("mask", {
  id: "a",
  width: "24",
  height: "24",
  x: "0",
  y: "0",
  maskUnits: "userSpaceOnUse",
  style: { "mask-type": "alpha" }
}, [
  /* @__PURE__ */ t("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  })
], -1), b0 = /* @__PURE__ */ t("g", { mask: "url(#a)" }, [
  /* @__PURE__ */ t("path", {
    fill: "#000",
    d: "M12.02 20.75c.684 0 1.287-.547 1.287-1.25h1.286c0 1.406-1.166 2.5-2.573 2.5-1.447 0-2.573-1.094-2.573-2.5h1.287c0 .703.563 1.25 1.286 1.25Zm8.402-5.664a1.84 1.84 0 0 1 .442 2.031c-.281.703-1.005 1.133-1.768 1.133H4.945c-.804 0-1.528-.43-1.81-1.133a1.84 1.84 0 0 1 .443-2.031c1.125-1.016 1.97-2.11 1.97-5.82 0-3.086 2.573-5.625 5.829-5.938v-.703c0-.313.281-.625.643-.625.322 0 .643.313.643.625v.703c3.216.313 5.79 2.852 5.79 5.938 0 3.71.844 4.804 1.97 5.82ZM19.096 17c.562 0 .844-.625.442-1.016-1.407-1.289-2.372-2.734-2.372-6.718 0-2.618-2.332-4.766-5.146-4.766-2.854 0-5.186 2.148-5.186 4.766 0 3.984-.965 5.43-2.372 6.718-.402.391-.12 1.016.483 1.016h14.15Z"
  })
], -1), T0 = [
  N0,
  b0
];
function U0(c, s) {
  return n(), e("svg", I0, T0);
}
const w5 = { render: U0 }, z0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, G0 = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "M5.308 20.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 0 1-.525-1.283V5.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h6.307V5H5.308a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v13.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096h13.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212v-6.307h1.5v6.307c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H5.308Zm4.411-5.165L8.665 14.28 17.946 5H14V3.5h6.5V10H19V6.054l-9.28 9.28Z"
}, null, -1), R0 = [
  G0
];
function W0(c, s) {
  return n(), e("svg", z0, R0);
}
const v5 = { render: W0 }, q0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "40",
  fill: "none"
}, j0 = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "M16.115 36.203V20.639L2.52 12.78V28c0 .102.026.198.077.288.051.09.128.167.23.23l13.29 7.685Zm2.27 0 13.288-7.684a.66.66 0 0 0 .23-.23.572.572 0 0 0 .078-.29V12.75l-13.596 7.89v15.564Zm-2.577 2.431-14.116-8.15a2.708 2.708 0 0 1-1.061-1.061A2.91 2.91 0 0 1 .25 27.98V12.02c0-.508.127-.989.38-1.442a2.709 2.709 0 0 1 1.062-1.062l14.116-8.15a2.91 2.91 0 0 1 1.442-.38c.508 0 .988.126 1.442.38l14.116 8.15c.453.254.807.608 1.061 1.062.254.454.38.934.38 1.442V27.98c0 .508-.126.989-.38 1.443a2.708 2.708 0 0 1-1.061 1.061l-14.116 8.15a2.91 2.91 0 0 1-1.442.381 2.91 2.91 0 0 1-1.442-.38Zm9.296-24.5 5.561-3.219L17.558 3.33a.683.683 0 0 0-.308-.076.683.683 0 0 0-.308.076l-5.215 3.008 13.377 7.796Zm-7.854 4.589 5.604-3.281L9.408 7.684l-5.604 3.231 13.446 7.808Z"
}, null, -1), J0 = [
  j0
];
function K0(c, s) {
  return n(), e("svg", q0, J0);
}
const g5 = { render: K0 }, Q0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, X0 = /* @__PURE__ */ t("path", { d: "M16 21.654 6.345 12l9.653-9.654 1.42 1.42L9.184 12l8.235 8.235-1.42 1.419Z" }, null, -1), Y0 = [
  X0
];
function t2(c, s) {
  return n(), e("svg", Q0, Y0);
}
const $5 = { render: t2 }, n2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, e2 = /* @__PURE__ */ t("path", { d: "m8.015 21.654-1.42-1.42L14.83 12 6.596 3.765l1.419-1.419L17.669 12l-9.654 9.654Z" }, null, -1), c2 = [
  e2
];
function s2(c, s) {
  return n(), e("svg", n2, c2);
}
const f5 = { render: s2 }, h2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "#0A0A0A"
}, o2 = /* @__PURE__ */ t("path", { d: "M12 11.692c-.963 0-1.787-.342-2.472-1.028C8.843 9.98 8.5 9.154 8.5 8.192s.343-1.786 1.028-2.471c.685-.686 1.51-1.029 2.472-1.029.963 0 1.786.343 2.472 1.029.685.685 1.028 1.509 1.028 2.471 0 .963-.343 1.787-1.028 2.472-.686.686-1.51 1.028-2.472 1.028Zm-7.5 7.616v-2.223c0-.49.133-.944.399-1.36a2.664 2.664 0 0 1 1.066-.963 14.507 14.507 0 0 1 2.992-1.09 12.95 12.95 0 0 1 6.086 0c1.006.242 2.003.605 2.992 1.09.444.224.8.545 1.066.962.266.417.399.87.399 1.36v2.224h-15Zm1.5-1.5h12v-.723a.98.98 0 0 0-.176-.563 1.333 1.333 0 0 0-.478-.422 12.854 12.854 0 0 0-2.635-.964 11.39 11.39 0 0 0-5.422 0c-.895.218-1.774.54-2.635.964-.201.109-.36.25-.478.422a.98.98 0 0 0-.176.563v.723Zm6-7.616c.55 0 1.02-.195 1.412-.587.392-.392.588-.863.588-1.413s-.196-1.02-.588-1.412A1.926 1.926 0 0 0 12 6.192c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0 0 10 8.192c0 .55.196 1.021.588 1.413.391.392.862.587 1.412.587Z" }, null, -1), l2 = [
  o2
];
function i2(c, s) {
  return n(), e("svg", h2, l2);
}
const u5 = { render: i2 }, r2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, d2 = /* @__PURE__ */ t("path", {
  fill: "#7E7E7E",
  d: "M15.773 12.973 14.65 11.85c.15-.828-.086-1.573-.709-2.234-.622-.66-1.386-.916-2.291-.766l-1.123-1.123A3.449 3.449 0 0 1 12 7.423c1.135 0 2.098.396 2.89 1.188.791.791 1.187 1.754 1.187 2.889 0 .282-.026.545-.076.788-.05.244-.127.472-.228.685Zm3.18 3.111L17.85 15.05a10.951 10.951 0 0 0 1.688-1.588A8.899 8.899 0 0 0 20.8 11.5c-.833-1.683-2.03-3.02-3.588-4.013C15.654 6.496 13.917 6 12 6c-.483 0-.958.033-1.425.1a9.625 9.625 0 0 0-1.375.3L8.035 5.235a10.096 10.096 0 0 1 1.936-.556c.66-.12 1.335-.18 2.029-.18 2.344.001 4.457.647 6.34 1.94 1.884 1.292 3.257 2.979 4.122 5.06-.371.894-.85 1.728-1.436 2.503a11.086 11.086 0 0 1-2.072 2.082Zm.809 5.785-4.047-4.015c-.512.19-1.08.345-1.704.465A10.6 10.6 0 0 1 12 18.5c-2.35 0-4.463-.645-6.34-1.938-1.877-1.292-3.251-2.979-4.122-5.061A11.11 11.11 0 0 1 2.97 9.028 11.366 11.366 0 0 1 4.9 7.038l-2.77-2.8 1.055-1.053 17.63 17.63-1.053 1.054ZM5.954 8.092A11.04 11.04 0 0 0 4.412 9.61c-.499.59-.903 1.22-1.212 1.89.833 1.684 2.03 3.022 3.587 4.013C8.346 16.504 10.083 17 12 17a8.07 8.07 0 0 0 1.36-.116c.45-.076.834-.156 1.148-.238l-1.266-1.296a3.616 3.616 0 0 1-1.242.227c-1.135 0-2.098-.396-2.89-1.188-.791-.791-1.187-1.755-1.187-2.89 0-.202.02-.414.062-.635.04-.22.096-.423.165-.606L5.954 8.092Z"
}, null, -1), _2 = [
  d2
];
function a2(c, s) {
  return n(), e("svg", r2, _2);
}
const p5 = { render: a2 }, w2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, v2 = /* @__PURE__ */ t("path", {
  fill: "#7E7E7E",
  d: "M12.002 15.577c1.133 0 2.096-.397 2.887-1.19.792-.793 1.188-1.756 1.188-2.89 0-1.132-.397-2.095-1.19-2.886-.793-.792-1.756-1.188-2.89-1.188-1.132 0-2.095.397-2.886 1.19-.792.793-1.188 1.756-1.188 2.89 0 1.132.397 2.095 1.19 2.886.793.792 1.756 1.188 2.89 1.188ZM12 14.2c-.75 0-1.387-.262-1.912-.787A2.604 2.604 0 0 1 9.3 11.5c0-.75.262-1.387.787-1.913A2.604 2.604 0 0 1 12 8.8c.75 0 1.387.262 1.912.787.525.526.788 1.163.788 1.913s-.262 1.387-.787 1.912A2.604 2.604 0 0 1 12 14.2Zm.001 4.3c-2.3 0-4.395-.634-6.286-1.903-1.89-1.269-3.283-2.968-4.177-5.097.894-2.13 2.286-3.829 4.176-5.097C7.604 5.134 9.699 4.5 11.999 4.5c2.3 0 4.394.634 6.286 1.903 1.89 1.268 3.283 2.967 4.177 5.097-.894 2.13-2.286 3.829-4.176 5.097C16.396 17.866 14.3 18.5 12 18.5ZM12 17a9.545 9.545 0 0 0 5.188-1.488A9.774 9.774 0 0 0 20.8 11.5a9.773 9.773 0 0 0-3.613-4.013A9.545 9.545 0 0 0 12 6a9.545 9.545 0 0 0-5.188 1.487A9.773 9.773 0 0 0 3.2 11.5a9.773 9.773 0 0 0 3.612 4.012A9.545 9.545 0 0 0 12 17Z"
}, null, -1), g2 = [
  v2
];
function $2(c, s) {
  return n(), e("svg", w2, g2);
}
const m5 = { render: $2 }, f2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}, u2 = /* @__PURE__ */ t("path", {
  fill: "#fff",
  d: "M3.938 9.562V8.438h10.124v1.124H3.938Z"
}, null, -1), p2 = [
  u2
];
function m2(c, s) {
  return n(), e("svg", f2, p2);
}
const Z5 = { render: m2 }, Z2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  fill: "none"
}, x2 = /* @__PURE__ */ t("g", {
  stroke: "#0A0A0A",
  "stroke-width": ".5"
}, [
  /* @__PURE__ */ t("path", { d: "m5 9 4-4M1 9l8-8" })
], -1), A2 = [
  x2
];
function M2(c, s) {
  return n(), e("svg", Z2, A2);
}
const x5 = { render: M2 }, H2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}, C2 = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "m16.543 17.577-6.281-6.28c-.5.412-1.075.735-1.725.968-.65.234-1.322.35-2.017.35-1.71 0-3.156-.591-4.34-1.775C.996 9.657.404 8.21.404 6.502c0-1.709.592-3.156 1.776-4.34C3.363.977 4.81.385 6.518.385c1.709 0 3.155.592 4.34 1.776 1.185 1.183 1.777 2.63 1.777 4.34 0 .713-.12 1.395-.36 2.045a5.72 5.72 0 0 1-.96 1.696l6.281 6.281-1.053 1.054ZM6.52 11.115c1.288 0 2.38-.447 3.274-1.34.894-.895 1.341-1.986 1.341-3.275 0-1.288-.447-2.38-1.341-3.274-.895-.894-1.986-1.341-3.274-1.341-1.289 0-2.38.447-3.274 1.341C2.35 4.12 1.904 5.212 1.904 6.5c0 1.289.447 2.38 1.342 3.274.894.894 1.985 1.342 3.274 1.342Z"
}, null, -1), L2 = [
  C2
];
function E2(c, s) {
  return n(), e("svg", H2, L2);
}
const A5 = { render: E2 }, k2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, V2 = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "M9.55 17.653 4.215 12.32l1.07-1.07 4.265 4.266 9.165-9.165 1.07 1.069L9.55 17.653Z"
}, null, -1), B2 = [
  V2
];
function F2(c, s) {
  return n(), e("svg", k2, B2);
}
const M5 = { render: F2 }, y2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}, S2 = /* @__PURE__ */ t("path", {
  fill: "#1C1B1F",
  d: "M5.694 10.141 2.73 7.178l.594-.594 2.37 2.37 5.092-5.093.594.594-5.686 5.686Z"
}, null, -1), D2 = [
  S2
];
function O2(c, s) {
  return n(), e("svg", y2, D2);
}
const H5 = { render: O2 }, P2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}, I2 = /* @__PURE__ */ t("path", {
  stroke: "#FAD200",
  "stroke-width": "3",
  d: "M18.531 1.076 1.561 18.047"
}, null, -1), N2 = [
  I2
];
function b2(c, s) {
  return n(), e("svg", P2, N2);
}
const C5 = { render: b2 }, T2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "36",
  fill: "none"
}, U2 = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "M37.25 15.915v16.7c0 .788-.284 1.465-.852 2.033-.568.568-1.245.852-2.033.852H5.085c-.787 0-1.465-.284-2.033-.852-.568-.568-.852-1.245-.852-2.033V15.877C1.28 15.14.663 14.222.35 13.119c-.313-1.102-.292-2.218.062-3.346l2.053-6.577c.267-.874.715-1.542 1.343-2.004C4.436.731 5.177.5 6.03.5h27.207c.895 0 1.673.233 2.335.698.662.465 1.12 1.119 1.373 1.96l2.143 6.615a5.655 5.655 0 0 1 .036 3.365 5.461 5.461 0 0 1-1.875 2.777Zm-13.038-1.05c1.146 0 2.065-.342 2.757-1.027.693-.684.979-1.457.858-2.319L26.5 2.77h-5.615v8.52c0 .956.318 1.791.955 2.505.638.714 1.428 1.071 2.372 1.071Zm-9.254 0c1.036 0 1.904-.348 2.606-1.046a3.438 3.438 0 0 0 1.051-2.53v-8.52h-5.634l-1.327 8.827c-.108.764.158 1.5.796 2.208.639.707 1.474 1.061 2.508 1.061Zm-9.043 0c.877 0 1.636-.3 2.277-.902a3.578 3.578 0 0 0 1.131-2.217l1.32-8.977h-5.04c-.217 0-.393.048-.528.144a.744.744 0 0 0-.279.433L2.65 10.3c-.359 1.11-.216 2.149.429 3.115.645.967 1.59 1.45 2.836 1.45Zm27.62 0c1.156 0 2.088-.462 2.794-1.386.706-.925.874-1.984.502-3.179l-2.166-6.992c-.05-.193-.144-.33-.278-.414-.135-.083-.311-.125-.53-.125H28.84l1.319 8.977a3.69 3.69 0 0 0 1.14 2.217c.635.602 1.38.902 2.237.902ZM5.085 33.231h29.28a.608.608 0 0 0 .616-.616V16.988c-.082.06-.267.099-.556.118-.288.019-.585.029-.89.029a5.247 5.247 0 0 1-2.366-.545c-.73-.363-1.443-.93-2.138-1.702a5.807 5.807 0 0 1-1.962 1.633c-.787.41-1.709.614-2.765.614-.923 0-1.737-.161-2.44-.483-.704-.322-1.409-.835-2.114-1.54a5.67 5.67 0 0 1-2.054 1.51 6.247 6.247 0 0 1-2.504.513c-.956 0-1.834-.174-2.634-.522-.8-.347-1.484-.922-2.05-1.725-.916.841-1.76 1.426-2.533 1.754-.773.329-1.46.493-2.06.493-.284 0-.557-.01-.819-.03a2.302 2.302 0 0 1-.627-.117v15.627a.608.608 0 0 0 .615.616Z"
}, null, -1), z2 = [
  U2
];
function G2(c, s) {
  return n(), e("svg", T2, z2);
}
const L5 = { render: G2 }, R2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, W2 = /* @__PURE__ */ t("path", {
  fill: "#FFE03E",
  d: "M21.001 8.895h-5.91l5.315-6.476c.11-.137.01-.336-.17-.336H9.95a.214.214 0 0 0-.185.103l-6.95 11.578c-.083.137.018.31.185.31h4.678L5.28 23.326c-.051.202.201.344.357.2L21.148 9.248c.14-.127.046-.354-.147-.354Z"
}, null, -1), q2 = [
  W2
];
function j2(c, s) {
  return n(), e("svg", R2, q2);
}
const E5 = { render: j2 }, J2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "23",
  fill: "none"
}, K2 = /* @__PURE__ */ t("path", {
  fill: "#FFE03E",
  stroke: "#1A1A1A",
  d: "M19.501 7.37h-5.91L18.907.896c.11-.137.01-.336-.17-.336H8.45a.214.214 0 0 0-.185.103L1.315 12.24c-.083.137.018.31.185.31h4.678L3.78 21.802c-.051.202.201.344.357.199L19.648 7.725c.14-.127.046-.354-.147-.354Z"
}, null, -1), Q2 = [
  K2
];
function X2(c, s) {
  return n(), e("svg", J2, Q2);
}
const k5 = { render: X2 }, Y2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, t3 = /* @__PURE__ */ t("path", {
  fill: "#35C27B",
  d: "m10.58 16.254 6.724-6.723-1.054-1.054-5.67 5.67-2.85-2.85-1.053 1.053 3.904 3.904Zm1.422 5.246a9.255 9.255 0 0 1-3.705-.748 9.596 9.596 0 0 1-3.018-2.03 9.591 9.591 0 0 1-2.03-3.016 9.245 9.245 0 0 1-.749-3.704c0-1.314.25-2.55.748-3.705a9.597 9.597 0 0 1 2.03-3.017 9.592 9.592 0 0 1 3.016-2.032 9.245 9.245 0 0 1 3.704-.748c1.314 0 2.55.25 3.705.748a9.597 9.597 0 0 1 3.018 2.03 9.592 9.592 0 0 1 2.03 3.016 9.245 9.245 0 0 1 .749 3.704c0 1.314-.25 2.55-.748 3.705a9.597 9.597 0 0 1-2.03 3.018 9.59 9.59 0 0 1-3.016 2.03 9.245 9.245 0 0 1-3.704.749Z"
}, null, -1), n3 = [
  t3
];
function e3(c, s) {
  return n(), e("svg", Y2, n3);
}
const V5 = { render: e3 }, c3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, s3 = /* @__PURE__ */ t("path", {
  fill: "#FF912C",
  d: "M1.865 20.5 12 3l10.134 17.5H1.865ZM12 17.808c.229 0 .42-.078.575-.232a.781.781 0 0 0 .232-.576.782.782 0 0 0-.232-.576.782.782 0 0 0-.575-.232.781.781 0 0 0-.576.232.782.782 0 0 0-.232.576c0 .229.078.42.232.576a.781.781 0 0 0 .576.232Zm-.75-2.616h1.5v-5h-1.5v5Z"
}, null, -1), h3 = [
  s3
];
function o3(c, s) {
  return n(), e("svg", c3, h3);
}
const B5 = { render: o3 }, l3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, i3 = /* @__PURE__ */ t("path", {
  fill: "#0A0A0A",
  d: "M7.308 20.5c-.499 0-.925-.177-1.278-.53a1.742 1.742 0 0 1-.53-1.278V6h-1V4.5H9v-.885h6V4.5h4.5V6h-1v12.692c0 .506-.175.933-.525 1.283-.35.35-.778.525-1.283.525H7.308ZM17 6H7v12.692a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h9.385a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212V6ZM9.404 17h1.5V8h-1.5v9Zm3.692 0h1.5V8h-1.5v9Z"
}, null, -1), r3 = [
  i3
];
function d3(c, s) {
  return n(), e("svg", l3, r3);
}
const F5 = { render: d3 }, _3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 24 24"
}, a3 = /* @__PURE__ */ t("path", { d: "M11.25 20.75v-5.5h1.5v2h8v1.5h-8v2h-1.5Zm-8-2v-1.5h5.5v1.5h-5.5Zm4-4v-2h-4v-1.5h4v-2h1.5v5.5h-1.5Zm4-2v-1.5h9.5v1.5h-9.5Zm4-4v-5.5h1.5v2h4v1.5h-4v2h-1.5Zm-12-2v-1.5h9.5v1.5h-9.5Z" }, null, -1), w3 = [
  a3
];
function v3(c, s) {
  return n(), e("svg", _3, w3);
}
const y5 = { render: v3 }, g3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none"
}, $3 = /* @__PURE__ */ t("path", {
  fill: "#2AA4EF",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), f3 = /* @__PURE__ */ t("path", {
  fill: "#fff",
  d: "M28.963 11.495a.49.49 0 0 1-.387-.139c-1.724-1.693-4.663-1.83-6.526-.247-1.384 1.094-2.113 3.082-1.69 4.88-3.648-.021-7.212-1.687-9.58-4.455a12.836 12.836 0 0 1-.532-.657c-1.546 2.161-.702 5.503 1.698 6.668a4.59 4.59 0 0 1-2.477-.65c-.158 2.439 1.656 4.577 4.042 4.855a4.65 4.65 0 0 1-2.329.112 4.612 4.612 0 0 0 4.607 3.42c-1.807 1.767-4.724 2.6-7.289 1.963 9.392 6.235 22.187-1.066 21.596-12.387.21-.15 2.457-1.892 2.403-2.519 0 0-2.165.842-2.639.648 0 0 0-.003-.003-.006.922-.586 1.828-1.685 2.067-2.634 0 0-1.639 1.029-2.961 1.148Z"
}, null, -1), u3 = [
  $3,
  f3
];
function p3(c, s) {
  return n(), e("svg", g3, u3);
}
const S5 = { render: p3 }, m3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "115",
  height: "32",
  fill: "none"
}, Z3 = /* @__PURE__ */ t("path", {
  fill: "#FFF5BF",
  d: "M115-26.413 57.5 32 0-26.413 8.453-35 57.5 14.825 106.547-35 115-26.413Z"
}, null, -1), x3 = [
  Z3
];
function A3(c, s) {
  return n(), e("svg", m3, x3);
}
const D5 = { render: A3 }, M3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 -960 960 960"
}, H3 = /* @__PURE__ */ t("path", { d: "m40-120 440-760 440 760H40Zm104-60h672L480-760 144-180Zm340.175-57q12.825 0 21.325-8.675 8.5-8.676 8.5-21.5 0-12.825-8.675-21.325-8.676-8.5-21.5-8.5-12.825 0-21.325 8.675-8.5 8.676-8.5 21.5 0 12.825 8.675 21.325 8.676 8.5 21.5 8.5ZM454-348h60v-224h-60v224Zm26-122Z" }, null, -1), C3 = [
  H3
];
function L3(c, s) {
  return n(), e("svg", M3, C3);
}
const O5 = { render: L3 }, E3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "41",
  height: "40",
  fill: "none"
}, k3 = /* @__PURE__ */ h('<g clip-path="url(#a)"><path fill="#0A0A0A" d="M20.5 40c11.046 0 20-8.954 20-20s-8.954-20-20-20S.5 8.954.5 20s8.954 20 20 20Z"></path><path fill="#fff" d="M22.308 18.469 29.38 10h-1.676l-6.142 7.353L16.658 10H11l7.418 11.12L11 30h1.676l6.486-7.765L24.342 30H30l-7.693-11.531Zm-2.296 2.748-.752-1.107-5.98-8.81h2.575l4.826 7.11.751 1.107 6.273 9.242h-2.574l-5.12-7.541Z"></path></g><defs><clipPath id="a"><rect width="40" height="40" x=".5" fill="#fff" rx="20"></rect></clipPath></defs>', 2), V3 = [
  k3
];
function B3(c, s) {
  return n(), e("svg", E3, V3);
}
const P5 = { render: B3 };
export {
  y3 as Add,
  S3 as BackSlash,
  D3 as Ball,
  O3 as CardClose,
  P3 as Caret,
  I3 as CaretDisabled,
  T3 as Cart,
  N3 as CartEmpty,
  b3 as CartHover,
  z3 as Check,
  U3 as CheckCircle,
  G3 as ChevronRight,
  R3 as Clear,
  W3 as Clock,
  q3 as Dot,
  j3 as Edit,
  J3 as Error,
  Q3 as External,
  K3 as ExternalHover,
  X3 as Help,
  Y3 as History,
  t5 as Info,
  n5 as Instagram,
  e5 as InvertedTriangle,
  c5 as Line,
  h5 as LinkArrow,
  s5 as LinkArrowHover,
  o5 as LocalShipping,
  l5 as MailCheck,
  i5 as ModalClose,
  r5 as ModalOpen,
  d5 as ModalWarning,
  _5 as MonetizationON,
  a5 as NarrowDown,
  w5 as Notification,
  v5 as OpenInNew,
  g5 as Package,
  f5 as PageNext,
  $5 as PagePrev,
  u5 as Person,
  p5 as PwdInvisible,
  m5 as PwdVisible,
  Z5 as Remove,
  x5 as Resize,
  A5 as Search,
  M5 as SelectCheck,
  C5 as Slash,
  H5 as StepCheck,
  L5 as StoreFront,
  E5 as Thunder,
  k5 as ThunderOriginal,
  V5 as ToastCheck,
  B5 as ToastWarning,
  F5 as Trash,
  y5 as Tune,
  S5 as Twitter,
  D5 as VMark,
  O5 as Warning,
  P5 as XIcon
};
